// state.js

export default {
    tasksList: [],
};
